import {
  LaptopOutline,
  NotificationOutline,
  UserOutline,
  ArrowLeftOutline
} from '@ant-design/icons-angular/icons';

export const ANT_ICONS = [
  LaptopOutline,
  NotificationOutline,
  UserOutline,
  ArrowLeftOutline
];
